<script setup>
</script>

<template>
    <footer class="bg-white sticky-footer">
        <div class="container my-auto">
            <div class="text-center my-auto copyright">
                <span>Copyright © innovaDigits {{ this.$dayjs().format('YYYY') }}</span>
            </div>
        </div>
    </footer>
</template>
